import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cmd-enter"
export default class extends Controller {
  connect() {
    this.boundKeydown = (e) => {
      if (!(e.keyCode == 13 && e.metaKey)) return;
      if (this.element.form) this.element.form.requestSubmit();
    };
    this.element.addEventListener("keydown", this.boundKeydown);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.boundKeydown);
  }
}
